import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import store from './data/store';
import SiteHeaderSearchDesktop from './ui/main';

export const initDesktopSearch = () => {
    const $root = document.getElementById('header-search-d-placeholder');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <SiteHeaderSearchDesktop />
            </Provider>
        </React.StrictMode>,
        $root
    );
};